
<div class="w-full h-full flex flex-col items-center justify-center gap-4">
  <p-progressSpinner ariaLabel="Redirecting to payment"/>
  @if (error()) {
    <p class="text-red-600 text-sm text-center px-4">{{ error() }}</p>
  } @else {
    <p class="text-surface-500 text-sm">Redirecting to payment...</p>
  }
</div>
